<script>
export default {
  name: 'PasswordInput',
  props: {
    label: {
      type: String,
      default: 'Password'
    },
    value: {
      type: String,
      required: false
    },
    id: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: 'password'
    },
    inputClass: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    feedback: {
      type: String,
      default: null
    },
    error: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      hidden: true
    }
  },
  computed: {
    inputClasses() {
      return [this.inputClass, this.hidden ? 'hidden' : 'visible']
    }
  },
  methods: {
    toggleVisibility() {
      this.hidden = !this.hidden
    },
    onInput(e) {
      this.currentValue = e.target.value
      this.$emit('input', this.currentValue)
    },
    onEvent(e) {
      this.$emit(e.type, e)
    }
  }
}
</script>

<template lang="pug">
.input.input--password(:class='{ error: error }')
  label(v-if='label' :for='id') {{ label }}
  p.body--small(v-if='description') {{ description }}

  .input__group
    input(
      :id='id'
      :type='this.hidden ? "password" : "text"'
      :name='name'
      :class='inputClasses'
      :value='value'
      autocomplete='current-password'
      @input='onInput'
      @keyup='onEvent'
      @focus='onEvent'
      @blur='onEvent'
      @change='onEvent'
    )

    .input__action
      a(href='#' @click.prevent='toggleVisibility') {{ this.hidden ? 'Show' : 'Hide' }}
  p.body--small.input__feedback(v-if='feedback')
    span {{ feedback }}
</template>

<style lang="stylus">
@import '../../assets/styles/modules/*'

.input--password
  input
    &.hidden
      letter-spacing: 4px
</style>
